import { render, staticRenderFns } from "./DetailTaxPph23Code.vue?vue&type=template&id=b0399a1c"
import script from "./DetailTaxPph23Code.vue?vue&type=script&lang=js"
export * from "./DetailTaxPph23Code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports